<template>
    <main class="min-h-screen bg-white  overflow-hidden flex flex-col">
      <!-- Background elements -->
      <UnderwaterBg class="fixed inset-0 z-0" />
      
      <!-- Header/Navigation -->
      <the-header
        :is-user-authenticated="isUserAuthenticated"
      />
  
      <!-- Main Content -->
      <div class="relative z-10 px-6 md:px-10 max-w-7xl mx-auto py-12 md:py-20 flex-grow flex items-center justify-center">
        <Motion
          :initial="{ opacity: 0, y: 20 }"
          :animate="{ opacity: 1, y: 0 }"
          :transition="{ duration: 0.5 }"
          class="w-full max-w-2xl backdrop-blur-sm bg-white/80  rounded-xl p-8 shadow-lg text-center"
        >
          <div class="py-8">
            <v-icon
              color="warning"
              size="64"
              class="mb-6"
            >
              mdi-cart-off
            </v-icon>
            
            <h1 class="text-3xl font-bold mb-4 text-slate-800 ">
              Payment Cancelled
            </h1>
            
            <p class="text-lg mb-8 text-gray-700 ">
              Your payment was cancelled and you haven't been charged.
            </p>
            
            <div class="flex flex-wrap justify-center gap-4">
              <v-btn
                color="primary"
                variant="elevated"
                size="large"
                to="/#pricing"
                prepend-icon="mdi-cart"
              >
                Try Again
              </v-btn>
              
              <v-btn
                variant="outlined"
                size="large"
                to="/contact"
                prepend-icon="mdi-email"
              >
                Contact Support
              </v-btn>
            </div>
          </div>
        </Motion>
      </div>
  
      <!-- Footer -->
      <the-footer />
    </main>
  </template>
  
  <script setup lang="ts">
  import { computed, onMounted } from 'vue';
  import { UnderwaterBg } from '@/components/ui/underwaterBg';
  import { useAuthStore } from '@/stores/authStore';
  import { Motion } from 'motion-v';
  import TheHeader from '@/components/layout/TheHeader.vue';
  import TheFooter from '@/components/layout/TheFooter.vue';
  import axios from 'axios';
  import { Constant } from '@/config/constants';
  
  const authStore = useAuthStore();
  
  // Computed property to check if user is authenticated
  const isUserAuthenticated = computed(() => {
    return authStore.isAuthenticated();
  });
  
  
  onMounted(async () => {
    
    // Notify backend about the cancelled payment
    try {
      await axios.get(`${Constant.API_URL}/checkout/cancel`);
    } catch (error) {
      console.error('Error notifying about cancelled payment:', error);
    }
  });
  </script>
  
  <style scoped>
  /* Add custom styles for payment cancel page */
  </style>